import { inject } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { UserContext } from '../../contexts/user-context';
import { ProjectModelService } from '../../services/project-model-service';

@inject(IRouter, ProjectModelService, UserContext)
export class Create {
    private _router: IRouter;
    private _project: ProjectModelService;
    private _userContext: UserContext;

    constructor(router: IRouter, project: ProjectModelService, userContext: UserContext) {
        this._router = router;
        this._project = project;
        this._userContext = userContext;
    }

    public loading(): void {
        const restoredDraftEventId = sessionStorage.getItem('restored_draft_event_id');
        if (restoredDraftEventId) {
            sessionStorage.removeItem('restored_draft_event_id');
            void this._router.load(`create/event-summary/${restoredDraftEventId}`);
            return;
        }

        // Resume an unsaved in-memory draft after email/passkey login (no page reload)
        const currentModel = this._project.currentModel;
        if (currentModel != null && currentModel.event.code == null) {
            void this._router.load(`create/event-summary/${currentModel.event.id}`);
            return;
        }

        // Clear any in-progress event so this entry route always starts fresh.
        this._project.clear();

        if (this._userContext.isLoggedIn) {
            void this._router.load('my-events');
            return;
        }

        const project = this._project.createNewProject();
        void this._router.load(`create/event-summary/${project.event.id}`);
    }
}
